import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const vehicleLocaleModule: LocaleModule = {
  name: "vehicle",
  messages: { en: en, it: it },
};
